import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng';
import { FormControl, FormGroup } from '@angular/forms';
import { AdditionalChargeService, BBWTMessageService } from '../../../services';
import { VmeCommonModule } from '../../../vme-common.module';

@Component({
  selector: 'request-additional-info',
  styleUrls: ['./request-additional-info.component.scss'],
  templateUrl: './request-additional-info.component.html',
  standalone: true,
  imports: [VmeCommonModule],
})
export class RequestAdditionalInfoComponent implements OnInit {
  @Input() additionalCharge: any;
  @Input() visible: boolean = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() requestInfoComplete = new EventEmitter<void>();

  loading: boolean;
  editForm: FormGroup<any>;
  isSending = false;
  allChoices: any;
  requestInfoChoices: any[];
  requestInfoId: any;

  constructor(
    private additionalChargeService: AdditionalChargeService,
    private messageService: BBWTMessageService,
  ) {
    this.editForm = new FormGroup({
      templateWrapperId: new FormControl(),
      additionalChargeId: new FormControl(),
      costQuestionId: new FormControl(),
      questionSubject: new FormControl(),
      questionText: new FormControl(),
      questionRecipientAddress: new FormControl(),
      questionFromName: new FormControl(),
      questionFromAddress: new FormControl(),
      questionReplyToAddress: new FormControl(),
      questionReplyToName: new FormControl(),
    });
  }

  ngOnInit() {
    this.getRequestInfoChoices().then((choices) => {
      this.allChoices = choices;
      this.requestInfoChoices = choices.map((item) => {
        return { value: item.id, label: item.headline };
      });
      this.requestInfoChoices.unshift({ value: 0, label: 'Select Info Request' });
    });
  }

  getRequestInfoChoices() {
    return this.additionalChargeService.RequestInfoChoiceSearch();
  }

  choiceChosen(choiceId: number) {
    if (choiceId > 0) {
      const templateChosen = this.allChoices.find((x) => x.id === choiceId);

      this.loading = true;
      this.additionalChargeService
        .getRequestInfoMail(this.additionalCharge.id, choiceId)
        .then((x) => {
          this.loading = false;

          this.editForm.patchValue({
            templateWrapperId: templateChosen.templateWrapperId,
            additionalChargeId: this.additionalCharge.id,
            costQuestionId: choiceId,
            questionSubject: x.subjectTemplate,
            questionText: x.bodyTemplate,
            questionRecipientAddress: x.recipientAddressTemplate,
            questionFromName: x.senderNameTemplate,
            questionFromAddress: x.senderAddressTemplate,
            questionReplyToName: x.replyToNameTemplate,
            questionReplyToAddress: x.replyToAddressTemplate,
          });
        });
    } else {
      // Clear the form
    }
  }

  sendRequestInfoMail() {
    this.isSending = true;
    const defaultReplyToAddress = this.editForm.get('questionFromAddress').value;
    if (!this.editForm.value?.questionReplyToAddress) {
      this.editForm.value.questionReplyToAddress = defaultReplyToAddress;
    }
    this.additionalChargeService
      .sendRequestInfoEmail(this.additionalCharge.id, this.editForm.value)
      .then((emailSent) => {
        if (!emailSent) {
          this.messageService.ShowError('Error', 'Additional Info Request Email was not sent');
        }
        this.requestInfoComplete.emit();
        this.isSending = false;
        this.closeDialog();
      });
  }

  closeDialog() {
    this.visibleChange.emit(false);
  }
}
